import React, { useEffect, useState } from "react";
import LoadingPage from "../Loading/loading";
import { proxy } from "../../config";
import "./cil.css";
import { useNavigate, useParams } from "react-router-dom";
import { acceptCil, getCil, pendingCil, rejectCil } from "../../api/cils";
import { Cookies } from "react-cookie";

const ViewCil = () => {
  const params = useParams();
  const navigate = useNavigate();
  const cookie = new Cookies();
  const [isSuper, setIsSuper] = useState(cookie.get("isSuper"));
  const [loading, setLoading] = useState();
  const [formData, setFormData] = useState(null);
  const [image, setImage] = useState(null);

  useEffect(() => {
    getCil(params.id).then((result) => {
      setFormData(result.data.response);
    });
  }, []);

  const handleChange = (e) => {
    e.target.setCustomValidity("");
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    e.target.setCustomValidity("");
    setImage(e.target.files[0]);
  };

  const reject = () => {
    setLoading(true);
    const formBack = new FormData();
    formBack.append("image", image);
    formBack.append("admin", "N/A");
    formBack.append("contact", "N/A");
    rejectCil(formData._id, formBack).then((result) => {
      setLoading(false);
      navigate(-1);
    });
  };

  const pending = () => {
    setLoading(true);
    pendingCil(formData._id).then((result) => {
      setLoading(false);
      navigate(-1);
    });
  };

  const accept = () => {
    setLoading(true);
    const formBack = new FormData();
    formBack.append("image", image);
    formBack.append("admin", formData.admin);
    formBack.append("contact", formData.contact);
    acceptCil(formData._id, formBack).then((result) => {
      setLoading(false);
      navigate(-1);
    });
  };

  return (
    <div className="main-content">
      {formData === null ? (
        <LoadingPage />
      ) : (
        <div className="add-brokers-guideline">
          <form>
            <div className="form-group">
              <label htmlFor="developer">Broker name</label>
              <input
                type="text"
                id="broker_name"
                name="broker_name"
                value={formData.user_id.name}
                disabled={true}
                placeholder="Enter broker name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="developer">Broker phone</label>
              <input
                type="text"
                id="broker_phone"
                name="broker_phone"
                value={formData.user_id.phone}
                disabled={true}
                placeholder="Enter broker phone"
              />
            </div>
            <div className="form-group">
              <label htmlFor="developer">Created at</label>
              <input
                type="text"
                id="broker_phone"
                name="broker_phone"
                value={formData.createdAt.split("T")[0]}
                disabled={true}
                placeholder="Enter broker phone"
              />
            </div>
            <div className="form-group">
              <label htmlFor="developer">Developer</label>
              <input
                type="text"
                id="developer"
                name="developer"
                value={formData.developer}
                disabled={true}
                placeholder="Enter developer"
              />
            </div>
            <div className="form-group">
              <label htmlFor="client_name">Client name</label>
              <input
                type="text"
                id="client_name"
                name="client_name"
                value={formData.client_name}
                disabled={true}
                placeholder="Enter client name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="developer">Client phone</label>
              <input
                type="text"
                id="client_phone"
                name="client_phone"
                value={formData.client_phone}
                disabled={true}
                placeholder="Enter client phone"
              />
            </div>
            <div className="form-group">
              <label htmlFor="developer">Project name</label>
              <input
                type="text"
                id="project_name"
                name="project_name"
                value={formData.project_name}
                disabled={true}
                placeholder="Enter project name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="developer">Sales name</label>
              <input
                type="text"
                id="sales_name"
                name="sales_name"
                value={formData.sales_name}
                disabled={true}
                placeholder="Enter sales name"
              />
            </div>
            <div className="form-group">
              <label htmlFor="developer">Sales phone</label>
              <input
                type="text"
                id="sales_phone"
                name="sales_phone"
                value={formData.sales_phone}
                disabled={true}
                placeholder="Enter salse phone"
              />
            </div>
            {params.cilType === "pending" && (
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="logo">Image</label>
                <div style={{ position: "relative", marginTop: "16px" }}>
                  {image && (
                    <div className="preview-item">
                      <img src={URL.createObjectURL(image)} alt="logo" />
                    </div>
                  )}
                  <input
                    type="file"
                    id="image"
                    name="image"
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                </div>
              </div>
            )}
            {params.cilType === "accept" && (
              <div
                className="form-group"
                style={{ flex: "1 1 calc(50% - 15px)", minWidth: "250px" }}
              >
                <label htmlFor="logo">Image</label>
                <div className="image-previews">
                  <div className="preview-item">
                    <img src={`${proxy}/${formData.image}`} alt={`Preview`} />
                  </div>
                </div>
              </div>
            )}
            {/*{(params.cilType === "pending" || params.cilType === "accept") && <>
                    <div className="form-group">
                        <label htmlFor="developer">Admin</label>
                        <input
                            type="text"
                            id="admin"
                            name="admin"
                            value={formData.admin}
                            onChange={handleChange}
                            placeholder="Enter admin"
                            disabled={params.cilType !== "pending"}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="developer">Contact</label>
                        <input
                            type="text"
                            id="contact"
                            name="contact"
                            value={formData.contact}
                            onChange={handleChange}
                            placeholder="Enter contact"
                            disabled={params.cilType !== "pending"}
                        />
                    </div>
                    {params.cilType === "pending" ?
                        <>
                            <>
                                {image !== null && <div className="preview-item">
                                    <img
                                        src={URL.createObjectURL(image)}
                                        alt={`Preview`}
                                    />
                                </div>}</>
                            <div className="form-group">
                                <input
                                    type="file"
                                    id="image"
                                    name="image"
                                    onChange={handleFileChange}
                                    accept="image/*"
                                />
                            </div>
                        </> :
                        <>
                            {formData.image === "" ? <div>No image</div> : <div className="preview-item">
                                <img
                                    src={`${proxy}/${formData.image}`}
                                    alt={`Preview`}
                                />
                            </div>}
                        </>
                    }
                </>}*/}
            {(params.cilType === "new" || params.cilType === "pending") && (
              <>
                {loading ? (
                  <div
                    style={{
                      width: "100%",
                      justifyContent: "center",
                      display: "flex",
                    }}
                  >
                    <div className="spinner"></div>
                  </div>
                ) : (
                  <div
                    className="choices-container"
                    style={{
                      display: "flex",
                      width: "100%",
                      gap: "15px", // Better than space-between for consistent spacing
                      flexWrap: "wrap",
                      marginTop: "10px",
                      justifyContent: "center",
                    }}
                  >
                    {params.cilType === "pending" && (
                      <button
                        onClick={() => {
                          reject();
                        }}
                        name="reject"
                        className={`action-btn remove-btn`}
                        style={{ width: "45%" }}
                      >
                        Reject
                      </button>
                    )}
                    {params.cilType === "new" ? (
                      <button
                        onClick={() => {
                          pending();
                        }}
                        name="pending"
                        className="action-btn ban-btn"
                        style={{ width: "45%" }}
                      >
                        Pending
                      </button>
                    ) : (
                      <button
                        onClick={() => {
                          accept();
                        }}
                        name="accept"
                        className="action-btn accept-btn"
                        style={{ width: "45%" }}
                      >
                        Accept
                      </button>
                    )}
                  </div>
                )}
              </>
            )}
          </form>
        </div>
      )}
    </div>
  );
};

export default ViewCil;
